import { Button } from 'cdk-radial';
import { FC } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { Tabs } from 'common/constants';
import { useFlagValue } from 'hooks/useFlags';
import { getSelectedTab } from 'pages/LandingPage/components/LandingPageHeader/slice';
import { buttonText, messages } from 'pages/VendorsTablePage/messages';
import { useAppSelector } from 'store/hooks';
import { getSelectedInvoicesLength } from '../../VendorsTable/slice';
import { singleInvoice } from './constants';
import {
  StyledButtonsContainer,
  StyledDeclineButton,
  StyledSelectedVendorsSpan
} from './styled';
import type { VendorsReviewSelectionProp } from './types';

export const VendorsReviewSelection: FC<VendorsReviewSelectionProp> = ({
  handleDeclineButtonClick,
  handleReviewButtonClick,
  isLoading
}) => {
  const intl: IntlShape = useIntl();
  const selectedInvoicesLength = useAppSelector(getSelectedInvoicesLength);
  const selectedTab = useAppSelector(getSelectedTab);
  const threeStepApprovalFlag = useFlagValue('dmsAccountingThreeStepApproval');

  return (
    <StyledButtonsContainer>
      {selectedInvoicesLength > 0 && (
        <StyledSelectedVendorsSpan>{`${selectedInvoicesLength} ${
          selectedInvoicesLength > singleInvoice
            ? intl.formatMessage(messages.invoicesSelected)
            : intl.formatMessage(messages.singleInvoiceSelected)
        }`}</StyledSelectedVendorsSpan>
      )}
      {threeStepApprovalFlag && selectedTab === Tabs.NeedsAuthorization && (
        <StyledDeclineButton
          dataTestId="review-decline-button"
          isDisabled={!selectedInvoicesLength}
          isLoading={isLoading}
          onClick={handleDeclineButtonClick}
          text={intl.formatMessage(buttonText.reviewVendorsDeclinePayment)}
        />
      )}
      <Button
        dataTestId="review-selected-button"
        isDisabled={!selectedInvoicesLength}
        onClick={handleReviewButtonClick}
        text={intl.formatMessage(buttonText.reviewVendorsInvoiceSelected)}
      />
    </StyledButtonsContainer>
  );
};
